import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Link } from '../'
import Styles from './Works.css'
import config from '../../config'

@CSSModules(Styles)
export default class Works extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    const iconOne = require('../../../static/images/icons_step1.svg')
    const iconTwo = require('../../../static/images/icons_step2.svg')
    const iconThree = require('../../../static/images/icons_step3.svg')
    const iconFour = require('../../../static/images/icons_step4.svg')

    return (
      <div styleName='works-wrap'>
        <div styleName='works'>
          <div styleName='works-inner'>
            <div styleName='works-title'>
              How to invest fossil free
            </div>
            <div styleName='works-steps-photos'>
              <div styleName='works-steps'>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step one icon'
                    src={iconOne}
                  />
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.clean}
                        title={'Search funds | '+config.app.title}
                        strong
                      >
                        Search for mutual funds and exchange-traded funds
                        (ETFs)
                      </Link>
                    </span> by name, ticker, or asset manager. Our database
                    covers 3,000 stock funds available in the U.S.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step two icon'
                    src={iconFour}
                  />
                  <div styleName='works-step-info'>
                    See your results. We track fund exposure to
                    fossil fuel companies, fossil finance and insurance, and
                    clean energy leaders.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step three icon'
                    src={iconTwo}
                  />
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.clean}
                        title={'Search funds | '+config.app.title}
                        strong
                      >
                        Look for greener options.
                      </Link>
                    </span> Sort and compare to find funds that fit your
                    needs.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step four icon'
                    src={iconThree}
                  />
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.toolkit}
                        title={'Action toolkit | '+config.app.title}
                        strong
                      >
                        Talk to your financial advisor or retirement plan
                        manager
                      </Link>
                    </span> about fossil free investing.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

